import { isDev } from '../../version'
import { consentFormTab, filesTab, insuranceInfoTab, labsTab, patientSummaryTab } from './shared'
import { ProfileTab, ProfileTabGroup, SubTab } from './types'

const pregnanciesTab: ProfileTab = {
  path: 'pregnancies',
  name: 'Pregnancies',
}
export const gynSubTabs: Array<SubTab> = [
  {
    path: 'profile',
    name: 'Intake Form',
  },
  {
    path: 'encounters',
    name: 'Encounters',
  },
]

export const gynTab: ProfileTabGroup = {
  path: 'gyn',
  name: 'GYN Care',
  children: gynSubTabs,
}
export const patientTab: ProfileTabGroup = {
  name: 'Patient',
  path: 'patient',
  children: [
    patientSummaryTab,
    pregnanciesTab,
    gynTab,
    insuranceInfoTab,
    filesTab,
    consentFormTab,
    // visitsTab,
  ],
}

export const v1PatientTabs: Array<SubTab> = [
  patientSummaryTab,
  pregnanciesTab,
  gynTab,
  insuranceInfoTab,
  ...(isDev ? [labsTab] : []),
  filesTab,
  // visitsTab,
  consentFormTab,
]
